/**
 * 管理后台的会话管理：access_token 仅存内存，刷新令牌走 httpOnly cookie。
 * `bootstrap()` 启动时尝试用 cookie 拉一次 /auth/me，拿到就用、拿不到回登录。
 */
import {
  apiRequest,
  bootstrapSession,
  configureApiClient,
  getApiClientConfig,
} from "@profitlens/api-client";
import type { LoginRequest, MeOut, TokenPair } from "@profitlens/api-client";

let accessToken: string | null = null;
const listeners = new Set<(authed: boolean) => void>();

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
  notify();
}

export function onAuthChange(fn: (authed: boolean) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function notify(): void {
  for (const fn of listeners) fn(accessToken !== null);
}

export function isAuthed(): boolean {
  return accessToken !== null;
}

let configured = false;
function ensureConfigured(): void {
  if (configured) return;
  configured = true;
  configureApiClient({
    baseUrl: "/api/v1",
    getAccessToken: () => getAccessToken(),
    setAccessToken: (token) => setAccessToken(token),
    onSessionExpired: () => setAccessToken(null),
  });
  // 让 getApiClientConfig 取到当前配置（避免被覆盖前返回默认）
  getApiClientConfig();
}

export async function bootstrap(): Promise<MeOut | null> {
  ensureConfigured();
  const me = await bootstrapSession();
  if (me) notify();
  return me;
}

export async function login(body: LoginRequest): Promise<TokenPair> {
  ensureConfigured();
  const tokens = await apiRequest<TokenPair>("/auth/login", { method: "POST", body });
  setAccessToken(tokens.access_token);
  return tokens;
}
